import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "./Title";
import SmallTitle from "./SmallTitle";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import SchoolIcon from "@material-ui/icons/School";
import ResumeItem from "./ResumeItem";

function Resume() {
  const briefcase = <BusinessCenterIcon />;
  const school = <SchoolIcon />;
  return (
    <ResumeStyled>
      <Title title={"Resume"} span={"resume"} />
      <InnerLayout>
        <div className="small-title">
          <SmallTitle icon={briefcase} title={"Working Experience"} />
        </div>
        <div className="resume-content">
          <ResumeItem
            year={"Aug 2019 - Present"}
            title={"Senior Analyst Quality Engineer"}
            subTitle={
              "National Australia Bank, Melbourne, Australia, Permanent Full-Time"
            }
            text={
              "Microservices Testing, Kafka, MQ Integration Testing, Working with AWS Environment and Dockers, Deployment in AWS Clusters and Production Support"
            }
          />
          <ResumeItem
            year={"Dec 2018 - Aug 2019"}
            title={"Test Automation Specialist Consultant"}
            subTitle={"Accenture, Melbourne, Australia, Permanent Full-Time"}
            text={
              "Designing and Developing a Core Test automation Framework for APIs and UI automation using Selenium, Cucumber, Java and which can be leveraged across multiple projects. Salesforce Enterprise CRM application testing and Saleforce API testing."
            }
          />
          <ResumeItem
            year={"May 2018 - Nov 2018"}
            title={"Senior Quality Assurance Analyst"}
            subTitle={"Accenture, Melbourne, Australia, Contract"}
            text={
              "Salesforce Enterprise CRM application testing and automation using selenium java webdriver, junit, cucumber. Continuous Integration using Jenkins."
            }
          />
          <ResumeItem
            year={"Mar 2018 - May 2018"}
            title={"Microservices Tester"}
            subTitle={"Telstra, Melbourne, Australia, Contract"}
            text={
              "Mocha-Nodejs Integration Automation Test Cases Scripting for REST APIs, Testing Microservices REST APIs in Postman."
            }
          />
          <ResumeItem
            year={"Nov 2016 - Jan 2018"}
            title={"Senior Automation Engineer"}
            subTitle={"Cisco, Bengaluru, India, Contract"}
            text={
              "Design and Development of Test Automation Framework for Web Application UI & Rest APIs using Selenium TestNG with Maven/Serenity BDD Framework, Java and Rest Assured/Serenity BDD-Serenity Rest Assured Framework, Testing Microservices APIs in AWS Environment"
            }
          />
          <ResumeItem
            year={"Sept 2016 - Nov 2016"}
            title={"Staff Quality Engineer"}
            subTitle={"eBay, Bengaluru, India, Contract"}
            text={
              "Designed and Developed framework for UI Automation using Selenium Java WebDriver with TestNG on Maven Project, Creating Continuous Integration Builds in Jenkins and monitoring them,Regression, Sanity Testing on Production."
            }
          />
          <ResumeItem
            year={"Jul 2014 - Sept 2016"}
            title={"QA Automation Engineer"}
            subTitle={"Cisco, Bengaluru, India, Contract"}
            text={
              "Design and Development of Test Automation Framework for Web Application UI & Rest APIs using Selenium TestNG with Maven, Java and Rest Assured"
            }
          />
          <ResumeItem
            year={"Jul 2013 - Jul 2014"}
            title={"Testing Engineer"}
            subTitle={"Nous Infosystems, Bengaluru, India, Permanent Full-Time"}
            text={
              "Designed and Developed framework for UI Automation using Selenium Java WebDriver with TestNG on Maven Project, Sahi-Pro Web Automation Tool"
            }
          />
          <ResumeItem
            year={"May 2010 - Jul 2012"}
            title={"QA Automation Engineer"}
            subTitle={"Tech Mahindra, Bengaluru, India, Permanent Full-Time"}
            text={
              "Participated in analyzing and evaluating the system or program requirements and contributed in creating use cases for the acceptance criteria. Coding the features in Java, using scripting languages as JavaScript, and performing Testing on the pieces of Developed Code. Involved in Writing Junit Test cases and Testing Developed Web Services API, Involved in writing SQL queries for Backend Validation using Oracle DB"
            }
          />
        </div>
        <div className="small-title u-small-title-margin">
          <SmallTitle icon={school} title={"Educational Qualifications"} />
        </div>
        <div className="resume-content ">
          <ResumeItem
            year={"2004 - 2008"}
            title={
              "Honors, Bachelors in Electronics and Communication Engineering Degree"
            }
            subTitle={
              "Gyan Ganga Institute of Technology and Sciences, Jabalpur, Madhya Pradesh, India"
            }
            /* text={
              "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa nihil impedit natus nostrum? Velit accusantium id quos, nihil vel quod.Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. "
            } */
          />
        </div>
      </InnerLayout>
    </ResumeStyled>
  );
}

const ResumeStyled = styled.section`
  .small-title {
    padding-bottom: 3rem;
  }
  .u-small-title-margin {
    margin-top: 4rem;
  }

  .resume-content {
    border-left: 2px solid var(--border-color);
  }
`;
export default Resume;
